import { chakra } from '@chakra-ui/system'
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import React from 'react'
export const BriddgyImage = chakra(({className,fit,...props})=>{
    return(
        <GatsbyImage  objectFit={fit||'contain'} className={className} {...props}/>
    )
})
